// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","form":"_2halzdTCsKOZUiar6gBSYw","horizontal":"wocmNKtNgxKI7Pbr-vY4s","centered":"_2QjHx4tcZOwricXAmrSDQU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Form.mod.css
// module id = 1052
// module chunks = 0